import { fetchApiData } from "../../utils/apiUtils";
import { ENDPOINT } from "../../constants/api";
import { setBranchList, setUser } from "../slices/pos.slice";

export const loginSlugless = (credentials) => async (dispatch) => {
  const data = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.POS_USER_BUSINESS_GROUP_PUBLIC}/login-slugless`,
    data: credentials,
    dispatch,
    useAuth: false,
  });
  return data;
};

export const login = (businessSlug, credentials) => async (dispatch) => {
  const data = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
      "{businessSlug}",
      businessSlug
    )}/login`,
    data: credentials,
    dispatch,
    useAuth: false,
  });
  return data;
};

export const forceLogin = (businessSlug, credentials) => async (dispatch) => {
  const data = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
      "{businessSlug}",
      businessSlug
    )}/force-login`,
    data: credentials,
    dispatch,
    useAuth: false,
  });
  return data;
};

export const logout = (businessSlug) => async (dispatch) => {
  const data = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
      "{businessSlug}",
      businessSlug
    )}/logout`,
    dispatch,
    useAuth: true,
  });
  return data;
};

export const getUserBusinessProfile = (businessSlug) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
      "{businessSlug}",
      businessSlug
    )}/profile`,
    dispatch,
    useAuth: true,
  });
  dispatch(setUser(data));
  return data;
};

export const requestPasswordReset =
  (businessSlug, email) => async (dispatch) => {
    const data = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
        "{businessSlug}",
        businessSlug
      )}/reset-password-request`,
      data: { email },
      dispatch,
      useAuth: false,
    });
    return data;
  };

export const resetPassword = (businessSlug, resetData) => async (dispatch) => {
  const data = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
      "{businessSlug}",
      businessSlug
    )}/reset-password`,
    data: resetData,
    dispatch,
    useAuth: false,
  });
  return data;
};

export const verifyRefreshToken =
  (businessSlug, refreshToken) => async (dispatch) => {
    const data = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
        "{businessSlug}",
        businessSlug
      )}/verify-refresh-token`,
      data: { refresh_token: refreshToken },
      dispatch,
      useAuth: false,
    });
    return data;
  };

export const changeEmployee =
  (businessSlug, credentials) => async (dispatch) => {
    const data = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
        "{businessSlug}",
        businessSlug
      )}/change-employee`,
      dispatch,
      useAuth: true,
      data: credentials,
    });
    return data;
  };

export const getUserBranch = (businessSlug) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
      "{businessSlug}",
      businessSlug
    )}/branch`,
    dispatch,
    useAuth: true,
  });
  if (data && Array.isArray(data)) {
    dispatch(setBranchList(data));
  }
  return data;
};

export const authenticateBranch =
  (businessSlug, branchData) => async (dispatch) => {
    const data = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
        "{businessSlug}",
        businessSlug
      )}/branch-auth`,
      data: branchData,
      dispatch,
      useAuth: true,
    });
    return data;
  };

export const testSendLogout = (businessSlug) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
      "{businessSlug}",
      businessSlug
    )}/test-send-logout`,
    dispatch,
    useAuth: true,
  });
  return data;
};

export const checkBusinessSlug = (businessSlug) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.POS_BUSINESS.replace(
      "{businessSlug}",
      businessSlug
    )}/check-business-slug`,
    dispatch,
    useAuth: true,
  });
  return data;
};

export const authenticateEmployee =
  (businessSlug, pinData) => async (dispatch) => {
    const data = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
        "{businessSlug}",
        businessSlug
      )}/employee-auth`,
      data: pinData,
      dispatch,
      useAuth: true,
    });
    return data;
  };

export const authenticateManagaer =
  (businessSlug, branchData) => async (dispatch) => {
    const data = await fetchApiData({
      method: "post",
      endpoint: `${ENDPOINT.USER_BUSINESS_GROUP.replace(
        "{businessSlug}",
        businessSlug
      )}/manager-auth`,
      data: branchData,
      dispatch,
      useAuth: true,
    });
    return data;
  };
